import script from "./RegistrationIntroductionView.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationIntroductionView.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationIntroductionView.vue?vue&type=style&index=0&id=1efe2511&scoped=true&lang=css"

import exportComponent from "../../../publisher/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1efe2511"]])

export default __exports__